export default function getCroppedImg(imageSrc, pixelCrop) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const canvas = document.createElement("canvas");
      const w = Math.max(1, Math.round(pixelCrop.width));
      const h = Math.max(1, Math.round(pixelCrop.height));
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height,
        0, 0, w, h
      );
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error("canvas vazio"))),
        "image/jpeg",
        0.9
      );
    };
    image.onerror = reject;
    image.src = imageSrc;
  });
}
